/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.baseURL = import.meta.env.VITE_API_DOMAIN;

// Catch all 401 responses and redirect to the login page, if not in login page
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
                return Promise.resolve();
            }
        }

        return Promise.reject(error);
    }
);

window.axios = axios;

// Disable console.logs in production
if (import.meta.env.VITE_APP_ENV === 'production') {
    console.log = function() {};
    // console.warn = function() {};
    // console.error = function() {};
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import './echo';
